import mailStore from 'owa-mail-store/lib/store/Store';
import getConversationReadingPaneViewState from '../utils/getConversationReadingPaneViewState';
import isNewestOnBottom from 'owa-mail-store/lib/utils/isNewestOnBottom';
import type ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import {
    isMeetingRequest,
    isEventPollRequest,
    isMeetingCancellation,
} from 'owa-meeting-message-utils';

export default function getLastestNonDraftItemId(
    conversationId: string,
    ignoreMeetingsItems?: boolean
): string {
    const conversationItemParts = mailStore().conversations.get(conversationId);
    const conversationNodeIds = conversationItemParts
        ? conversationItemParts.conversationNodeIds
        : [];
    const conversationNodeIdCount = conversationNodeIds.length;
    const conversationViewState = getConversationReadingPaneViewState(conversationId);
    if (conversationNodeIdCount == 0 || !conversationViewState) {
        return '';
    }

    const itemPartsMap = conversationViewState.itemPartsMap;
    let index = isNewestOnBottom() ? conversationNodeIdCount - 1 : 0;
    const indexIncrement = isNewestOnBottom() ? -1 : 1;
    while (index >= 0 && index < conversationNodeIdCount) {
        const itemPart = itemPartsMap.get(conversationNodeIds[index]);
        const item = itemPart ? mailStore().items.get(itemPart.itemId) : null;
        if (
            item &&
            !item.IsDraft &&
            !itemPart?.isInRollUp &&
            !shouldIgnoreMeetingItem(item, !!ignoreMeetingsItems)
        ) {
            return item.ItemId?.Id ?? '';
        }
        index += indexIncrement;
    }

    return '';
}

function shouldIgnoreMeetingItem(item: ClientItem, ignoreMeetingsItems: boolean): boolean {
    return (
        ignoreMeetingsItems &&
        (isMeetingRequest(item.ItemClass) ||
            isEventPollRequest(item.ItemClass) ||
            isMeetingCancellation(item.ItemClass))
    );
}
